var _style, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430 132",
    style: {
      enableBackground: "new 0 0 430 132"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#7BAB41;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1C1A50;stroke-miterlimit:10;}\n\t.st3{opacity:0.2;fill:#1C1A50;}\n\t.st4{fill:none;stroke:#7BAB41;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.69,100.33h56.32v20.09H26.58V12.1h26.11V100.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.35,140.16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.36,95.44h56.32v20.09H21.25V7.21h26.11V95.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.43,47.48l-73.88,73.88l-14.2-14.2l92.34-92.34l76.59,76.59l-18.46,18.46L260.43,47.48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.66,47.17l-73.88,73.88l-14.2-14.2l92.34-92.34l76.59,76.59l-18.46,18.46L267.66,47.17z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "144.06,20.16 200.6,20.16 172.33,69.12 144.06,118.09 115.79,69.12 87.53,20.16 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "152.6,15.14 209.14,15.14 180.87,64.1 152.6,113.06 124.33,64.1 96.07,15.14 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.68,149.45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.76,109.87l-18.46-18.46l76.59-76.59l92.34,92.34l-14.2,14.2l-73.88-73.88L268.76,109.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M261.52,109.56L243.06,91.1l76.59-76.59L412,106.84l-14.2,14.2l-73.88-73.88L261.52,109.56z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M449.39,149.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/Animation.89509d5fddbfc02cd347e82c7069dd2c.svg";
export { ForwardRef as ReactComponent };